import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const ContentInfo = styled.div`
  padding: 0px 10px;
  overflow: auto;
  height: 100%;
  .img-container {
    padding: 20px 0;
    display: flex;
    justify-content: center;
    img {
      width: 157px;
      height: 270px;
      border-radius: 16px;
      border-width: 2.81px;
      object-fit: cover;
    }
  }
  .separator{
    width: 100%;
    border-bottom: 1px solid #E6E6E6;
  }
  .title {
    font-family: Nunito Sans Bold;
    font-size: 17px;
    color: #3E3E5B;
    margin: 10px 0;
  }
  .categories {
    color: #1F1F52;
    font-family: Nunito Sans;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .description {
    color: #7B7798;
    font-family: Nunito Sans;
    font-size: 14px;
  }
`;